import { render, staticRenderFns } from "./QuizCoinPackagesGrid.vue?vue&type=template&id=66742eb4&"
import script from "./QuizCoinPackagesGrid.vue?vue&type=script&lang=js&"
export * from "./QuizCoinPackagesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports